<!-- currently hides "separator" items in button-big style menu-->
<!-- TODO use styling to differentiate between separators and actual menu items instead of *ngIf?-->
<!-- Implement small pill style menu-->

<!--TileBig-->
<ng-container *ngIf="dsMenu && dsMenu.objectNode && dsMenu.objectNode.Menu_Item">
  <div *ngIf="layout == MenuLayoutType.TileBig" [class]="columnClass ? 'row' : 'btn-group'">
    <div
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="tilebigcontextmenu"
      [style.display]="menuitem.Type == 'separator' ? separatorDisplay : columnClass ? '' : 'block'"
      [class]="columnClass ? columnClass : ''"
    >
      <button unity-button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        classes="ghost"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        (contextmenu)="$event.preventDefault()"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [class.disabled]="checkDisabled(menuitem)"
      >
        {{ menuitem.Label }}
      </button>
      <div
        *ngIf="menuitem.Type == 'separator'"
        style="font-weight: 800; font-size: 1.3em"
        [style.color]="separator == 'inline' ? 'white' : 'darkslategrey'"
        [style.transform]="separator == 'inline' ? 'rotate(300deg)' : null"
      >
        <span>
          {{ menuitem.Label }}
        </span>
      </div>
      <multi-tab-context-menu #tilebigcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--TileSmall-->
  <div class="btn-group" *ngIf="layout == MenuLayoutType.TileSmall">
    <div
      style="display: inline-block"
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="tilesmallcontextmenu"
    >
      <a
        *ngIf="validMenuItem(menuitem)"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        (contextmenu)="$event.preventDefault()"
        [class]="'btn btn-app ' + color(menuitem)"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [style.min-width]="menuitem.Type == 'separator' ? '0px' : '47px'"
        style="
          height: 47px;
          margin-top: -1px;
          margin-bottom: 0;
          border-radius: 0px;
          margin-left: 0px;
          margin-right: -1px;
          cursor: pointer;
          position: relative;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <i [class]="menuitem.Icon" style="font-size: 20px"></i>
      </a>
      <multi-tab-context-menu #tilesmallcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--Sidebar-->
  <div
    *ngIf="layout == MenuLayoutType.Sidebar"
    class="sidebar unity-card"
    style="padding: var(--unity-spacing-02) var(--unity-spacing-06)"
  >
    <div
      [class]="menuitem.Type == 'separator' ? 'py-2' : 'pb-1'"
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [class.header]="menuitem.Type == 'separator'"
      [style.font]="menuitem.Type == 'separator' ? 'var(--unity-font-headline-small)' : ''"
      [style.color]="menuitem.Type == 'separator' ? 'var(--unity-semantic-color-foreground-neutral-primary)' : ''"
      [multiTabContextMenuTrigger]="sidebarcontextmenu"
    >
      <button unity-button
        classes="ghost"
        *ngIf="!(menuitem.Type && menuitem.Type == 'separator') && validMenuItem(menuitem)"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        (contextmenu)="$event.preventDefault()"
        style="cursor: pointer"
        [disabled]="checkDisabled(menuitem)"
      >
        <ng-template #menuItemTooltipContent>
          <div *ngIf="menuitem.Tooltip">{{ menuitem.Tooltip }}</div>
          <div *ngIf="!menuitem.Tooltip">{{ menuitem.Label }}</div>
          <div *ngIf="menuitem.Flag">
            <table style="font-size: 12px; color: white">
              <tr *ngFor="let flag of menuitem.Flag">
                <td>{{ flag.Tooltip }}</td>
              </tr>
            </table>
          </div>
        </ng-template>
        <span>{{ menuitem.Label }}</span>
        <unity-badge *ngIf="menuitem.Badge" class="muted ms-2">
          {{ menuitem.Badge }}
        </unity-badge>
        <!-- <span *ngIf="menuitem.Flag">
            <i *ngFor="let flag of menuitem.Flag" [class]="'fa ' + flag.Icon" style="margin-left: 5px"></i>
          </span> -->
      </button>
      <span *ngIf="menuitem.Type == 'separator'" style="text-transform: uppercase">{{ menuitem.Label }}</span>
      <multi-tab-context-menu #sidebarcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--Hyperlink-->
  <div *ngIf="layout == MenuLayoutType.Hyperlink" [class]="columnClass ? 'row' : ''">
    <div
      [style]="columnClass ? '' : 'display: inline-flex; gap: 0.75em'"
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="hyperlinkcontextmenu"
      [class]="columnClass ? columnClass : ''"
    >
      <button unity-button
        *ngIf="validMenuItem(menuitem)"
        [manualID]="buildIDAttribute(menuitem)"
        [class]="menuitem.Color == 'on_dark' ? 'link on_dark' : 'link link-small'"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        title=""
        (click)="runAction(menuitem)"
        [disabled]="checkDisabled(menuitem)"
      >
        {{ menuitem.Label }}
        <unity-badge *ngIf="menuitem.Badge" class="muted info ms-2">
          {{ menuitem.Badge }}
        </unity-badge>
      </button>
      <multi-tab-context-menu #hyperlinkcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </div>
  </div>

  <!--Toolbar-->
  <div
    class="ms-1"
    *ngIf="layout == MenuLayoutType.Toolbar"
    style="display: flex; column-gap: 2px; align-items: center"
  >
    <ng-container
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="toolbarcontextmenu"
    >
      <button unity-button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator' && menuitem.Type != 'dropdownMenu'"
        [class]="!menuitem.ShowButtonLabel ? ' icon-only' : color(menuitem)"
        [icon]="!menuitem.ShowButtonLabel ? menuitem.Icon : null"
        (click)="runAction(menuitem)"
        [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        [manualID]="buildIDAttribute(menuitem)"
        [dirty]="checkDirty(menuitem)"
        [loading]="checkLoading(menuitem)"
        [disabled]="checkDisabled(menuitem)"
      >
        <i
          *ngIf="!menuitem.ShowButtonLabel && !menuitem.Icon.includes('unity-icon')"
          [class]="'fa fw ' + menuitem.Icon"
        ></i>
        <svg
          *ngIf="!menuitem.ShowButtonLabel && menuitem.Icon.includes('unity-icon')"
          [class]="'unity-icon ' + menuitem.Icon"
        >
          <use attr.xlink:href="#{{ menuitem.Icon }}"></use>
        </svg>
        {{ menuitem.ShowButtonLabel == true ? menuitem.Label : null }}
      </button>

      <div
        *ngIf="
          validMenuItem(menuitem) &&
          menuitem.Type == 'dropdownMenu' &&
          menuitem.DropDownMenuItems &&
          menuitem.DropDownMenuItems.length > 0
        "
        ngbDropdown
        placement="bottom-right"
        [autoClose]="true"
      >
        <button unity-button
          classes="icon-only"
          type="button"
          ngbDropdownToggle
          [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        >
          <svg *ngIf="menuitem.Icon.includes('unity-icon')" [class]="'unity-icon ' + menuitem.Icon">
            <use attr.xlink:href="#{{ menuitem.Icon }}"></use>
          </svg>
        </button>
        <div ngbDropdownMenu class="unity-menu dropdown">
          <ul>
            <ng-container *ngFor="let dropdownMenuItem of menuitem.DropDownMenuItems">
              <li ngbDropdownItem *ngIf="validMenuItem(dropdownMenuItem)">
                <button unity-button classes="block" type="button" (click)="runAction(dropdownMenuItem)">
                  <span class="label">{{ dropdownMenuItem.Label }}</span>
                </button>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>

      <multi-tab-context-menu #toolbarcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </ng-container>
  </div>

  <div
    class="btn-group"
    *ngIf="layout == MenuLayoutType.TileText"
    style="width: 100%; background-color: blanchedalmond"
  >
    <ng-container *ngFor="let menuitem of dsMenu.objectNode.Menu_Item">
      <button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        [class]="'btn btn-app ' + color(menuitem)"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        [style.min-width]="menuitem.Type == 'separator' ? '0px' : '77px'"
        [style.max-width]="menuitem.Type == 'separator' ? '0px' : '77px'"
        style="
          height: 79px;
          margin-top: -1px;
          margin-bottom: 0;
          border-radius: 0px;
          margin-left: 0px;
          margin-right: -1px;
          cursor: pointer;
          background-color: floralwhite;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <div style="font-size: 12px; white-space: pre-line; vertical-align: middle">{{ menuitem.Label }}</div>
        <unity-badge *ngIf="menuitem.Badge" class="muted info ms-2" style="top: 60px; right: 4px">
          {{ menuitem.Badge }}
        </unity-badge>
      </button>
      <div
        *ngIf="validMenuItem(menuitem) && menuitem.Type == 'separator'"
        style="
          height: 25px;
          width: 100%;
          font-weight: 600;
          background-color: var(--unity-semantic-color-surface-base-neutral-standard);
          border-bottom: 1px solid var(--unity-primitive-color-gray-020);
          color: var(--unity-semantic-color-foreground-neutral-primary);
          display: block;
          padding: 4px;
          text-transform: uppercase;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <div style="font-size: 12px; white-space: pre-line; vertical-align: middle">{{ menuitem.Label }}</div>
      </div>
    </ng-container>
  </div>
  <!-- HACK 52e7ef7e-5f9e-48d6-9a06-67c4fb748645
       10/9/2021  Hack to add support to "Text" Menu type  (see other changed on action-menu component  -->
  <div class="btn-group" *ngIf="layout == MenuLayoutType.Text" style="width: 100%; background-color: whitesmoke">
    <ng-container *ngFor="let menuitem of dsMenu.objectNode.Menu_Item">
      <button
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        [manualID]="buildIDAttribute(menuitem)"
        (click)="runAction(menuitem)"
        [class]="'btn btn-menu-text'"
        [style.display]="menuitem.Type == 'separator' ? 'none' : 'inherit'"
        [title]="menuitem.Tooltip"
        style="
          height: 20px;
          margin-top: 0;
          margin-bottom: 0;
          margin-left: 0px;
          margin-right: 12px;
          cursor: pointer;
          border: none;
          padding: 2px 2px 2px 2px;
        "
        [class.disabled]="checkDisabled(menuitem)"
      >
        <div style="font-size: 13px; white-space: pre-line; vertical-align: middle">
          {{ menuitem.Label.toUpperCase() }}
        </div>
        <unity-badge *ngIf="menuitem.Badge" class="muted info ms-2" style="top: 60px; right: 4px">
          {{ menuitem.Badge }}
        </unity-badge>
      </button>
    </ng-container>
  </div>
  <!-- END HACK 52e7ef7e-5f9e-48d6-9a06-67c4fb748645 -->

  <!---Prototype for cascading launch menu ----->
  <!--Cascade -->
  <div *ngIf="layout == MenuLayoutType.Cascade" class="prototypeMenuCascade">
    <div *ngFor="let menuSection of cascadeMenu" class="menu-header">
      <span
        *ngIf="menuSection.Child_Menu_Item && menuSection.Child_Menu_Item.length > 0"
        style="text-transform: uppercase"
        >{{ menuSection.Label }}</span
      >
      <div *ngFor="let menuitem of menuSection.Child_Menu_Item" [multiTabContextMenuTrigger]="cascadecontextmenu">
        <a
          *ngIf="!(menuitem.Type && menuitem.Type == 'separator') && validMenuItem(menuitem)"
          [manualID]="buildIDAttribute(menuitem)"
          (click)="runAction(menuitem)"
          [title]="menuItemTooltipContent"
          style="cursor: pointer"
          [class.disabled]="checkDisabled(menuitem)"
          class="menu-item"
        >
          <ng-template #menuItemTooltipContent>
            <div *ngIf="menuitem.Tooltip">{{ menuitem.Tooltip }}</div>
            <div *ngIf="!menuitem.Tooltip">{{ menuitem.Label }}</div>
            <div *ngIf="menuitem.Flag">
              <table style="font-size: 12px; color: white">
                <tr *ngFor="let flag of menuitem.Flag">
                  <td>{{ flag.Tooltip }}</td>
                </tr>
              </table>
            </div>
          </ng-template>
          <span>{{ menuitem.Label }}</span>
          <unity-badge *ngIf="menuitem.Badge" class="muted info ms-2">
            {{ menuitem.Badge }}
          </unity-badge>

          <span *ngIf="menuitem.Flag">
            <i *ngFor="let flag of menuitem.Flag" [class]="'fa ' + flag.Icon" style="margin-left: 5px"></i>
          </span>
        </a>
        <multi-tab-context-menu #cascadecontextmenu>
          <a
            href="Javascript:;"
            name="NewTab"
            style="
              display: block;
              color: #ffffff;
              cursor: pointer;
              font-size: 14px;
              padding: 0px 10px 5px 10px;
              border-bottom: 1px solid;
            "
            (click)="runActionInNewTab($event, menuitem)"
            >Open in New Tab</a
          >
          <a
            href="Javascript:;"
            name="NewWindow"
            style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
            (click)="runActionInNewWindow($event, menuitem)"
            >Open in New Window</a
          >
        </multi-tab-context-menu>
      </div>
    </div>
    <!-- {{ cascadeMenu | json }} -->
  </div>
  <!---END Prototype for cascading launch menu ----->

  <!--Unity-->
  <nav class="unity-tabs small" *ngIf="layout == MenuLayoutType.Unity">
    <button unity-button
      *ngIf="isNotAuthenticated"
      disabled="disabled"
      classes="link link-black"
      title="Cannot Go Back to Previous Page"
    >
      <svg class="unity-icon unity-icon-arrow-left">
        <use xlink:href="#unity-icon-arrow-left"></use>
      </svg>
      Back
    </button>
    <button unity-button classes="link link-back link-small" (click)="goBack()" ngbTooltip="Go Back to Previous Page">
      <svg class="unity-icon unity-icon-arrow-left">
        <use xlink:href="#unity-icon-arrow-left"></use>
      </svg>
      Back
    </button>
    <ng-container
      *ngFor="let menuitem of dsMenu.objectNode.Menu_Item"
      [multiTabContextMenuTrigger]="hyperlinkcontextmenu"
    >
      <a
        *ngIf="validMenuItem(menuitem) && menuitem.Type != 'separator'"
        class="unity-tab"
        [class.on]="menuitem.Url && pLocation._location.href.includes(menuitem.Url[0])"
        [manualID]="buildIDAttribute(menuitem)"
        [title]="menuitem.Tooltip ? menuitem.Tooltip : menuitem.Label"
        (click)="runAction(menuitem)"
        [attr.disabled]="checkDisabled(menuitem)"
      >
        {{ menuitem.Label }}
        <unity-badge *ngIf="menuitem.Badge" class="muted info">
          {{ menuitem.Badge }}
        </unity-badge>
      </a>
      <multi-tab-context-menu #hyperlinkcontextmenu>
        <a
          href="Javascript:;"
          name="NewTab"
          style="
            display: block;
            color: #ffffff;
            cursor: pointer;
            font-size: 14px;
            padding: 0px 10px 5px 10px;
            border-bottom: 1px solid;
          "
          (click)="runActionInNewTab($event, menuitem)"
          >Open in New Tab</a
        >
        <a
          href="Javascript:;"
          name="NewWindow"
          style="display: block; color: #ffffff; cursor: pointer; font-size: 14px; padding: 5px 10px 0px 10px"
          (click)="runActionInNewWindow($event, menuitem)"
          >Open in New Window</a
        >
      </multi-tab-context-menu>
    </ng-container>
  </nav>
</ng-container>
